import { Stack } from '@mui/material';
import { ReportStatuses } from '@schooly/api';
import { FC, PropsWithChildren, useCallback } from 'react';

import { DropdownSelect, DropdownSelectProps } from '../DropdownSelect';
import { renderReportStatusTags } from './ReportStatusExpandedSelect';

type ReportStatusSelectMultipleProps = PropsWithChildren<{
  selectedStatuses: ReportStatuses[];
  onSelectStatus: (v: ReportStatuses) => void;
}> &
  Omit<DropdownSelectProps, 'children' | 'renderContent'>;

const OPTIONS = [ReportStatuses.Published, ReportStatuses.Unpublished, ReportStatuses.Draft];

export const ReportStatusSelectMultiple: FC<ReportStatusSelectMultipleProps> = ({
  selectedStatuses,
  onSelectStatus,
  placeholder,
  ...dropdownProps
}) => {
  const renderContent = useCallback(() => {
    return (
      <Stack direction="row" flexWrap="wrap" gap={1} m={1}>
        {renderReportStatusTags({
          statuses: OPTIONS,
          tagProps: (status) => ({
            variant: selectedStatuses.includes(status) ? 'filled' : undefined,
          }),
          onClick: onSelectStatus,
        })}
      </Stack>
    );
  }, [onSelectStatus, selectedStatuses]);

  return (
    <DropdownSelect
      {...dropdownProps}
      placeholder={placeholder}
      hasValues={!!selectedStatuses.length}
      renderContent={renderContent}
    >
      {(opened) => (
        <>
          {renderReportStatusTags({
            statuses: selectedStatuses,
            tagProps: { size: placeholder ? 'small' : undefined },
            onDelete: opened ? onSelectStatus : undefined,
          })}
        </>
      )}
    </DropdownSelect>
  );
};
